<template>
    <div>
        <header class="panel__header">
            <h1 class="panel__title">Subscription</h1>
        </header>
        <p>Your account is currently on Skybase <strong>{{ currentPlan }}</strong> plan <template v-if="isCancelled">and ends at <strong>{{ subscriptionEndsAt }}</strong></template></p>
        <p v-if="hasPaymentMethod">
            Payment method: <strong>{{ paymentMethodDetails }}</strong> <a href="#" @click.prevent="$emit('page', 'update-payment-method')">update</a>
        </p>
        <div class="plans">
            <div class="plans__item" :class="{'plans__item--selected' : isNotSubscribed}">
                <div class="plans__item__title">Free</div>
                <div>
                    <div class="highlight">Up to 5 users</div>
                    <div>Unlimited single channel guests</div>
                    <div>Unlimited channels</div>
                    <div>2GB storage space</div>
                    <div>All features</div>
                    <div>Free support</div>
                </div>
            </div>
            <div class="plans__item" :class="{'plans__item--selected' : isSubscribed}">
                <div class="plans__item__title">Pro</div>
                <div>
                    <div class="highlight">&dollar;{{ yearlyPrice }} per user monthly</div>
                    <div>Unlimited single channel guests</div>
                    <div>Unlimited channels</div>
                    <div>100GB storage space</div>
                    <div>All features</div>
                    <div>Free support</div>
                    <div class="plans__item__actions">
                        <template v-if="isSubscribed">
                            <action-confirmation v-if="isCancelled" :callback="resumeSubscription">
                                <template slot="title">Resume subscription</template>
                                <template slot="message">Your subscription will renew at the end of the current billing cycle</template>
                                <button class="button button--primary">Resume</button>
                            </action-confirmation>
                            <action-confirmation action="Confirm" destructive v-else :callback="cancelSubscription">
                                <template slot="title">Cancel subscription</template>
                                <template slot="message">Your subscription will stop at the end of the current billing cycle</template>
                                <button class="button button--danger">Cancel</button>
                            </action-confirmation>
                        </template>
                        <button v-else @click="$emit('page', 'upgrade')" class="button button--primary">Upgrade</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
/* global EventBus */
import { mapState } from 'vuex'
import ActionConfirmation from '../../Global/ActionConfirmation'
import currentTenantAware from '../../../mixins/currentTenantAware'

export default {
    mixins: [currentTenantAware],

    methods: {
        cancelSubscription () {
            return this.$store.dispatch('tenant/cancelSubscription').then(() => {
                EventBus.$emit('newSnackbar', 'Subscription cancelled')
            })
        },

        resumeSubscription () {
            return this.$store.dispatch('tenant/resumeSubscription').then(() => {
                EventBus.$emit('newSnackbar', 'Subscription resumed')
            })
        }
    },

    computed: {
        ...mapState('tenant', ['yearlyPrice'])
    },

    components: {
        ActionConfirmation
    }
}

</script>
